import React from "react";
import { updateDb } from "../services/updateDb";
import { useNavigate } from "react-router-dom";

import AlertMessage from "../common/AlertMessage";
import UserForm from "./UserForm";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";

const AddUserPage = () => {
  const { t } = useTranslation();
  const { currentOrg, currentProject, showAlertMessage, alertMessage } = useAppContext();
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    let userObj = {
      name: data.name,
      email: data.email,
      role: data.role,
      orgId: data.orgId || currentOrg.id,
      projectId: data.projectId || currentProject.id,
      language: data.language || 'en',
    };

    const res = await updateDb("/api/users/", userObj);

    if (res.success) {
      navigate("/users", { state: { message: t('user') + " " + t('added'), type: "success" } });
    } else if (res.error) {
      showAlertMessage('error', res.error ? res.error : 'Error adding user.');
    }
  };

  return (
    <div id="content">
      <div id="content-title">{t('add_user')}</div>

      <AlertMessage type={alertMessage.type} message={alertMessage.content} />

      <div className="content-bubble">
        <UserForm
          handleSubmit={handleSubmit}
          text={t('add_user')}
        />
      </div>
    </div>
  );
};

export default AddUserPage;
